import React from 'react';
import { useNavigate } from 'react-router-dom';
import { languages } from '../translations';
import ResponsiveContainer from './ResponsiveContainer';

function LanguageSelectionPage({ currentLanguage, setCurrentLanguage, t }) {
  const navigate = useNavigate();

  const handleLanguageSelect = (language) => {
    setCurrentLanguage(language);
  };

  const handleDone = () => {
    // Navigate to personal details page
    navigate('/email-input');
  };

  return (
    <ResponsiveContainer>
      <div className="min-h-[calc(100vh-100px)] bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <h2 className="text-2xl font-semibold text-center mb-6">{t('selectPreferredLanguage')}</h2>
          
          <div className="space-y-4 mb-8">
            {languages.map((language) => (
              <button
                key={language}
                onClick={() => handleLanguageSelect(language)}
                className={`w-full p-4 rounded-lg text-center transition-colors duration-200 ${
                  currentLanguage === language 
                    ? 'bg-[#d0a949] text-white' 
                    : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                }`}
              >
                {language}
              </button>
            ))}
          </div>
          
          <div className="flex justify-center mt-6">
            <button
              onClick={handleDone}
              className="bg-[#d0a949] hover:bg-[#a6873a] text-white py-3 px-6 rounded-lg shadow transition duration-200"
            >
              {t('doneButton')}
            </button>
          </div>
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/goal-selection')}
              className="text-gray-500 hover:text-gray-700 text-sm"
            >
              {t('cancelRegistration')}
            </button>
          </div>
          
        </div>
      </div>
    </ResponsiveContainer>
  );
}

export default LanguageSelectionPage;